// 深拷贝对象
export function deepClone(obj) {
  const _toString = Object.prototype.toString

  // null, undefined, non-object, function
  if (!obj || typeof obj !== 'object') {
    return obj
  }

  // DOM Node
  if (obj.nodeType && 'cloneNode' in obj) {
    return obj.cloneNode(true)
  }

  // Date
  if (_toString.call(obj) === '[object Date]') {
    return new Date(obj.getTime())
  }

  // RegExp
  if (_toString.call(obj) === '[object RegExp]') {
    const flags = []
    if (obj.global) { flags.push('g') }
    if (obj.multiline) { flags.push('m') }
    if (obj.ignoreCase) { flags.push('i') }

    return new RegExp(obj.source, flags.join(''))
  }

  const result = Array.isArray(obj) ? [] : obj.constructor ? new obj.constructor() : {}

  for (const key in obj) {
    result[key] = deepClone(obj[key])
  }

  return result
}

/**
 * @description: 获取路径中的参数，以对象形式返回
 * @param {String} url 需要解析的路径字符串
 * @return {Object}
 */
export const getUrlSearchParams = (url) => {
  if (typeof (url) !== 'string') return {};
  const [, searchStr] = url.split('?');
  if (!searchStr) return {};
  let obj = {}
  for (const str of searchStr.split('&')) {
    const [name, value] = str.split('=');
    obj[name] = decodeURIComponent(value)
  }
  return obj
}

// 当前是否是微信环境
export const isWeixin = () => {
  return navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1;
}

// 转换字符串，undefined,null等转化为""
export function praseStrEmpty(str) {
	if (!str || str == "undefined" || str == "null") {
		return "";
	}
	return str;
}